import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getCurrentEvent } from '../services/api';
import pickNPrayLogoNoText from '../Logos/LogoNoText.png';

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return;
    getCurrentEvent()
      .then(res => setIsLive(res.data?.status === 'locked'))
      .catch(() => {});
  }, [isAuthenticated, location.pathname]);

  const isActive = (path) => location.pathname === path;

  const handleLogout = async () => {
    await logout();
    navigate('/');
    setMobileMenuOpen(false);
  };

  const closeMenu = () => setMobileMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="container navbar-content">
        <Link to={isAuthenticated ? '/dashboard' : '/'} className="navbar-brand" onClick={closeMenu}>
          <img src={pickNPrayLogoNoText} alt="Pick 'N Pray logo" style={{ height: '50px', width: 'auto' }} />
        </Link>

        {/* Mobile menu button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(prev => !prev)}
          aria-label="Toggle menu"
          type="button"
        >
          <span className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <div className={`navbar-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          {isAuthenticated ? (
            <>
              <Link to="/dashboard" className={`navbar-link ${isActive('/dashboard') ? 'active' : ''}`} onClick={closeMenu}>
                Dashboard
              </Link>
              <Link to="/live" className={`navbar-link ${isActive('/live') ? 'active' : ''}`} onClick={closeMenu}>
                Leaderboards
                {isLive && <span className="nav-live-badge">LIVE</span>}
              </Link>
              <Link to="/join" className={`navbar-link ${isActive('/join') ? 'active' : ''}`} onClick={closeMenu}>
                Join Pool
              </Link>
              <Link to="/badges" className={`navbar-link ${isActive('/badges') ? 'active' : ''}`} onClick={closeMenu}>
                Badges
              </Link>
              <Link to="/lock-sheet" className={`navbar-link ${isActive('/lock-sheet') ? 'active' : ''}`} onClick={closeMenu}>
                Lock Sheet
              </Link>
              <div className="navbar-user-section">
                <Link
                  to="/profile"
                  onClick={closeMenu}
                  style={{ color: 'var(--text-muted)', fontSize: '14px', textDecoration: 'none' }}
                  className="navbar-link"
                >
                  {user?.username}
                </Link>
                <button
                  className="btn btn-secondary"
                  style={{ padding: '6px 12px', fontSize: '14px' }}
                  onClick={handleLogout}
                >
                  Logout
                </button>
                <a
                  href="https://x.com/picknpraymma"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="navbar-link"
                  title="Follow us on X"
                  style={{ marginLeft: '8px' }}
                >
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/picknpray_mma/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="navbar-link"
                  title="Follow us on Instagram"
                  style={{ marginLeft: '8px' }}
                >
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
            </>
          ) : (
            <>
              <Link to="/" className={`navbar-link ${isActive('/') ? 'active' : ''}`} onClick={closeMenu}>
                Home
              </Link>
              <Link to="/faq" className={`navbar-link ${isActive('/faq') ? 'active' : ''}`} onClick={closeMenu}>
                FAQ
              </Link>
              <Link to="/login" className={`navbar-link ${isActive('/login') ? 'active' : ''}`} onClick={closeMenu}>
                Login
              </Link>
              <Link to="/register" className="btn btn-primary" style={{ padding: '8px 16px' }} onClick={closeMenu}>
                Sign Up
              </Link>
              <a
                href="https://x.com/picknpraymma"
                target="_blank"
                rel="noopener noreferrer"
                className="navbar-link"
                title="Follow us on X"
                style={{ marginLeft: '8px' }}
              >
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/picknpray_mma/"
                target="_blank"
                rel="noopener noreferrer"
                className="navbar-link"
                title="Follow us on Instagram"
                style={{ marginLeft: '8px' }}
              >
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
